<div class="flex flex-col py-2 bg-red-500" style="background-color: #022b3a; padding: 0 24px;">
  <div class="heading flex flex-row justify-between">
    <h2 class="text-white">Box Pickup Sites</h2>
  </div>
</div>

<div class="box-pickup-sites-container">
  <div class="box-pickup-sites-content">
    <div class="box-pickup-sites-header flex justify-between items-center">
      <div class="box-pickup-sites-title flex flex-row items-center">
        <img src="/assets/icons/box_pickup.svg" alt="Users" />
        <div class="title">Box Pickup Sites</div>
      </div>
      <div>
        <a *ngIf="canManageBoxPickupSites$.value" class="button-add" (click)="promptAddNewDialog()">Add</a>
      </div>
    </div>
    <div>
      <mat-table #table (matSortChange)="sortTable($event)" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <mat-header-cell class="grow2 possible-long-text" *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell
            class="grow2 possible-long-text"
            *matCellDef="let row"
            matTooltip="{{ row.name }}"
            matTooltipPosition="above"
            saAutomatedSelector="user__name"
            >{{ row.name || 'No Name' }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="oorMiles">
          <mat-header-cell class="grow1half" *matHeaderCellDef mat-sort-header>Out of Route Miles</mat-header-cell>
          <mat-cell class="grow1half" *matCellDef="let row" saAutomatedSelector="user__name"
            >{{ row.outOfRouteMiles || '-' }} miles</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="rate">
          <mat-header-cell class="grow1" *matHeaderCellDef mat-sort-header>$ / Mile</mat-header-cell>
          <mat-cell class="grow1" *matCellDef="let row" saAutomatedSelector="user__name"
            >${{ (row.outOfRouteRateCents / 100).toFixed(2) || '-' }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell class="grow2" *matHeaderCellDef mat-sort-header>Created At</mat-header-cell>
          <mat-cell class="grow2" *matCellDef="let row" saAutomatedSelector="user__name">{{
            (row.createdAt | standardDate) || '-'
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="directions">
          <mat-header-cell class="grow2 possible-long-text" *matHeaderCellDef mat-sort-header
            >Directions</mat-header-cell
          >
          <mat-cell
            class="grow2 truncate"
            *matCellDef="let row"
            matTooltip="{{ row.directions }}"
            matTooltipPosition="above"
            saAutomatedSelector="user__name"
            >{{ row.directions || '-' }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell class="grid justify-items-end" *matCellDef="let row" saAutomatedSelector="user__edit">
            <div class="flex">
              <i
                class="w-1/2 material-icons cursor-pointer"
                style="padding-right: 16px;"
                (click)="promptEditDialog(row)"
                >edit</i
              >
              <i class="w-1/2 material-icons cursor-pointer" (click)="promptRemoveDialog(row)"
                ><mat-icon color="warn">delete</mat-icon></i
              >
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          saAutomatedSelector="user__row"
          [automatedName]="row.name"
        ></mat-row>
        <div *matNoDataRow><div class="ml-5 mt-2">There are no sites</div></div>
      </mat-table>
    </div>
  </div>
</div>
